@if (isVisible) {
  <div class="grid-x">
    <div class="cell">
      <form-control-label [question]="componentData"></form-control-label>
    </div>
    <div class="cell">
      <button class="button" [id]="controlId" (click)="navigate()" >
        {{ this.componentData.config.text || 'Link' }}
      </button>
    </div>
  </div>
}